import React, {useEffect, useRef, useState} from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import "./style.scss";
import {DialogContent, TextField} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CheckIcon from '@material-ui/icons/Check';

export default function SchedulerDialog({isOpen, onCloseDialog, onChooseMinutes}) {
    const [customMinutes, setCustomMinutes] = useState("");
    const openRef = useRef();

    useEffect(() => {
        if (isOpen) {
            setCustomMinutes("");
            openRef.current = new Date();
        }
    }, [isOpen]);

    function askParentToCloseDialog() {
        const millisecondsSinceOpen = new Date() - openRef.current;

        if (onCloseDialog && millisecondsSinceOpen > 200) {
            onCloseDialog()
        }
    }

    function handleCustomMinutesChange(e) {
        const val = e.target.value;

        if (parseInt(val) > 0 || val === "")
            setCustomMinutes(val);
    }

    function handleChooseMinutes(minutes) {
        if (onChooseMinutes)
            onChooseMinutes(minutes);
    }

    function renderSpecificTimeButton(minutes) {
        let text = "";

        if (minutes === 0)
            text = "עכשיו";
        else if (minutes === 1)
            text = "דקה";
        else
            text = minutes + " דקות";

        return (
            <Button variant="contained" color="primary" className="scheduler-option specific-time-button"
                    onClick={() => handleChooseMinutes(minutes)}>
                {text}
            </Button>
        );
    }

    return (
        <Dialog className="scheduler-dialog" open={isOpen} onClose={askParentToCloseDialog}>
            <DialogTitle>
                מתי ההזמנה תהיה מוכנה?
            </DialogTitle>
            <DialogContent className="scheduler-dialog-content">
                <div className="scheduler-options">
                    {renderSpecificTimeButton(0)}
                    {renderSpecificTimeButton(5)}
                    {renderSpecificTimeButton(10)}
                    <span className="scheduler-option custom-time-wrapper">
                        <TextField placeholder="זמן אחר" type="number" value={customMinutes}
                                   onChange={handleCustomMinutesChange}/>
                        <Button
                            className={'save-custom-time ' + (customMinutes ? 'save-custom-time-show' : 'save-custom-time-hidden')}
                            onClick={() => handleChooseMinutes(parseInt(customMinutes))}>
                            <CheckIcon/>
                        </Button>
                    </span>
                </div>
            </DialogContent>
            <DialogActions className="scheduler-actions">
            </DialogActions>
        </Dialog>
    );
}